<template>
  <div class="container">
    <header-child :status="true" ref="breadCrumbs"></header-child>
    <!-- 面包屑 -->
    <bread-crumbs
      ref="crumbs"
      :title="title"
      :totalNumber="totalNumber"
    ></bread-crumbs>
    <div class="content lft">
      <!-- 一级分类 -->
      <div class="left">
        <div class="classificationss" @mouseleave="firstLevelMovedOut(1)">
          <div
            class="firstClassClassification"
            @click="clickOnTheTitle(1, null, null)"
            :class="firstClassClassBelow == null ? 'active' : ''"
            :style="
              firstClassClassBelow1 == null
                ? 'background:#edc18a;color:#ffffff;opacity: .7'
                : ''
            "
            @mouseenter="switchClassification(1, 0, null)"
          >
            <div>
              <span>Все</span>
            </div>
          </div>
          <!-- <div style="height: 40px"></div> -->
          <div
            v-for="(item, index) in firstClass"
            :key="index"
            class="firstClassClassification"
            @click="clickOnTheTitle(1, index, item.name, item.id)"
            :class="firstClassClassBelow === index ? 'active' : ''"
            :style="
              firstClassClassBelow1 == index
                ? 'background:#edc18a;opacity: .7;color:#ffffff'
                : ''
            "
            @mouseenter="switchClassification(1, index, 'все', item.id)"
          >
            <div>
              <span>{{ item.name }}</span
              ><img src="../../../assets/images/sort_icon_more_n.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 二级分类 -->
        <!--  -->
        <div
          @mouseleave="firstLevelMovedOut()"
          @mouseenter="secondaryTransfer()"
          class="secondary-classification"
          v-if="secondaryClassification"
        >
          <div class="classification">
            <div
              v-for="(item, index) in twoClass"
              :key="index"
              :style="
                secondaryClassificationSubscript2 == index
                  ? 'background:#edc18a;opacity: .7;color:#ffffff'
                  : ''
              "
              :class="secondaryClassificationSubscript == index ? 'active' : ''"
              @mouseleave="subsequent(2)"
              @click="clickOnTheTitle(2, index, item.name, item.id)"
              class="firstClassClassification"
              @mouseenter="switchClassification(2, index, item.name, item.id)"
            >
              <!--  -->
              <div>
                <span>{{ item.name }}</span
                ><img
                  src="../../../assets/images/sort_icon_more_n.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 三级分类 -->
        <div
          v-if="level_3Classification"
          @mouseenter="clear()"
          @mouseleave="firstLevelMovedOut()"
        >
          <div class="san-classification">
            <div
              v-for="(item, index) in threeList"
              :key="index"
              class="firstClassClassification"
              :style="
                level_3ClassificationIndex2 == index
                  ? 'background:#edc18a;opacity: .7;color:#ffffff'
                  : ''
              "
              @click="clickOnTheTitle(3, index, item.name, item.id)"
              :class="level_3ClassificationIndex == index ? 'active' : ''"
              @mouseenter="switchClassification(3, index, item.name, item.id)"
            >
              <div>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 新款商品 -->
        <div class="new-product" v-if="false">
          <div class="title">
            <img src="../../../assets/images/sort_icon_new.png" alt="" />
            <span>новые товары </span>
          </div>
          <div class="new-product-list">
            <div
              class="commodity"
              v-for="(item, index) in newList"
              :key="index"
              @click="graffitiPopUpWindow(item, index, 1, 1)"
            >
              <img
                :src="item.graffiti_img ? item.graffiti_img : item.images[0]"
                alt=""
                ref="tuya"
              />
              <span class="name">Новый</span>
              <span class="money">
                {{ calculateThePrice(item.price * 1) }} p
              </span>
              <img
                v-if="item.added"
                class="added"
                src="../../../assets/images/icon_checked.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div class="right" v-if="largePicture">
        <img
          class="air"
          v-if="productList.length == 0"
          src="../../../assets/images/kongzhuangtai@2x.png"
          alt=""
        />
        <div
          class="productList"
          v-for="(item, index) in productList"
          :key="index"
        >
          <div class="img">
            <el-image
              :src="item.graffiti_img ? item.graffiti_img : item.images[0]"
              lazy
              @click="graffitiPopUpWindow(item, index, 2)"
            >
              <div slot="error" class="image-slot">
                <span>Ошибка загрузки</span>
              </div>
              <div
                slot="placeholder"
                class="image-slot"
                v-loading="loading"
                element-loading-background="rgba(0, 0, 0, 0.2)"
              >
                <span class="dot"></span>
              </div>
            </el-image>
            <!-- <img
              class="productList-img"
              :src="item.graffiti_img ? item.graffiti_img : item.images[0]"
              alt=""
            /> -->
            <img
              v-if="item.added"
              class="added"
              src="../../../assets/images/icon_checked.png"
              alt=""
              @click="graffitiPopUpWindow(item, index, 2)"
            />

            <!-- <img class="sort" src="../../../assets/images/sort_icon_edit.png" alt="" /> -->
          </div>

          <div class="product-message">
            <p class="title">{{ item.name }}</p>
            <p class="content">
              {{ item.intro }}
            </p>
            <p class="money">
              Цена：<span class="cu-red">{{ parseFloat(item.price) }}p</span>
              Cумма：
              <input
                type="number"
                onkeyup="this.value=this.value.replace(/\D/g,'')"
                onafterpaste="this.value=this.value.replace(/\D/g,'')"
                v-model="item.cartinfo.quantity"
                class="num"
              />x{{ item.packages }}
              <span style="margin-right: 20px"></span> Итого：<span
                class="xi-red"
                >{{
                  calculateThePrice(
                    item.price * item.cartinfo.quantity * item.packages
                  )
                }}p
              </span>
            </p>
            <div class="favorable">
              <p>
                -3%：<span
                  >{{ parseFloat((item.price * 0.97).toFixed(1)) }}p</span
                >
              </p>
              <p>
                -6%：<span
                  >{{ parseFloat((item.price * 0.94).toFixed(1)) }}p</span
                >
              </p>
              <p>
                -8%：<span
                  >{{ parseFloat((item.price * 0.92).toFixed(1)) }}p</span
                >
              </p>
            </div>
            <el-button
              type="warning"
              round
              @click="addToShoppingCart(item, index)"
              >Добавить в корзину
            </el-button>
            <div class="note">
              <span></span>
              <div></div>
              <textarea
                placeholder="примечан"
                cols="30"
                rows="4"
                v-model="item.cartinfo.desc"
              >
              </textarea>
              <!-- <input type="text" name="" id="" v-model="item.note" /> -->
            </div>
          </div>
          <el-divider></el-divider>
        </div>
      </div>
      <div v-if="!largePicture" class="right">
        <div
          class="big-map"
          v-for="(item, index) in productList"
          :key="index"
          :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
          @click="graffitiPopUpWindow(item, index, 2)"
        >
          <el-image
            :src="item.graffiti_img ? item.graffiti_img : item.images[0]"
            lazy
          >
            <div slot="error" class="image-slot">
              <span>Ошибка загрузки</span>
            </div>
            <div
              slot="placeholder"
              class="image-slot"
              v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.2)"
            >
              <span class="dot"></span>
            </div>
          </el-image>
          <span class="money">{{ parseFloat(item.price) }} p</span>
          <img
            v-if="item.added"
            class="added"
            src="../../../assets/images/icon_checked.png"
            alt=""
          />
        </div>
      </div>
      <div v-if="fullWidth >= 1400" class="advertising">
        <img src="../../../assets/images/zhekou.png" alt="" />
      </div>
    </div>

    <el-dialog
      v-if="graffiti"
      :visible.sync="graffiti"
      width="1072px"
      :before-close="handleClose"
      :closeOnClickModal="false"
    >
      <div class="canvas-container">
        <!-- v-if="productList[commodity].images.length != 1" -->
        <span
          class="position"
          :style="
            subscriptIndex != 0
              ? 'background: #FFFFFF;color: #848484; transition: all .2s;'
              : ''
          "
          >{{ subscriptIndex + 1 + "/" + graffitiGoods.images.length }}</span
        >
        <el-carousel
          :interval="5000"
          @arrow="!load ? 'always' : 'none'"
          :autoplay="false"
          @change="subscript"
          :initial-index="subscriptIndex"
        >
          <el-carousel-item
            v-for="(item, index) in graffitiGoods.images"
            :key="index"
          >
            <div
              v-loading="load"
              v-if="index == 0"
              class="aoligei"
              ref="aoligei"
              element-loading-background="rgba(0, 0, 0, 0.3)"
            ></div>
            <img v-if="index > 0" :src="item" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="information">
        <span class="introduction">{{ graffitiGoods.intro }}</span
        ><br />
        <div class="note">
          <img src="../../../assets/images/me_iocn_bianji.png" alt="" />
          <textarea
            v-model="graffitiGoods.cartinfo.desc"
            placeholder="Примечания"
          ></textarea>
        </div>

        <p>
          <span class="unit-price" style="font-weight: bold; color: #ff3b3b"
            >{{ parseFloat(graffitiGoods.price) }}p </span
          >x
          <input
            type="number"
            v-model="graffitiGoods.cartinfo.quantity"
            @keyup.enter="addShowToShoppingCart"
          />
          x {{ graffitiGoods.packages }} =
          {{
            calculateThePrice(
              graffitiGoods.price *
                graffitiGoods.cartinfo.quantity *
                graffitiGoods.packages
            )
          }}
          p
        </p>
        <div class="favorable">
          <p>
            -3%：<span class="s1"
              >{{ parseFloat((graffitiGoods.price * 0.97).toFixed(1)) }}p</span
            >
          </p>
          <p>
            -6%：<span class="s1"
              >{{ parseFloat((graffitiGoods.price * 0.94).toFixed(1)) }}p</span
            >
          </p>
          <p>
            -8%：<span class="s1"
              >{{ parseFloat((graffitiGoods.price * 0.92).toFixed(1)) }}p</span
            >
          </p>
        </div>
        <el-button class="join" type="warning" @click="addShowToShoppingCart()"
          >Добавить</el-button
        >
      </div>
      <graffiti
        ref="graffiti"
        :imgPath="imgPath"
        :subscriptIndex="subscriptIndex"
        :graffiti="load"
      />
    </el-dialog>
  </div>
</template>

<script>
import headerChild from "../../../components/Header";
import breadCrumbs from "../../../components/HomeBreadCrumbs";
import { num } from "../../../api/method";
// import SignCanvas from "sign-canvas";
import Graffiti from "../../../components/Graffiti";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { headerChild, breadCrumbs, Graffiti },
  data() {
    //数据
    return {
      // imgUrl: "",
      subscriptIndex: 0,
      commodity: {},
      largePicture: true, //切换大图
      title: "", //面包屑title
      title2: "",
      firstClass: [], //一级分类列表
      firstClassTitle: "", //一级标题
      firstClassClicks: null, //保存点击一级下标
      firstClassClassBelow: null, //一级分类下标
      firstClassClassBelow1: "null",
      twoClass: [], //二级分类列表
      secondaryTitle: "", //二级标题
      secondaryClassClicks: null, //保存点击er级下标
      secondaryClassification: false, //二级分类
      secondaryClassificationSubscript: null, //二级分裂下标
      secondaryClassificationSubscript2: null,
      threeList: [], //三级分类列表
      threeLevelTitle: "", //三级标题
      threeClassClicks: null, //保存点击二级下标
      level_3Classification: false, //三级分类
      level_3ClassificationIndex: null, //三级分类下标
      level_3ClassificationIndex2: null,
      timer: null, //定时器
      timer2: null,
      newList: [], //新款商品列表
      classificationId_1: "", //分类id
      classificationId_2: "",
      classificationId_3: "",
      textarea: "", //文本域
      fullWidth: document.documentElement.clientWidth, //实时屏幕宽度
      totalNumber: null, //商品总数
      productList: [], //商品列表
      item_id: [], //加入购物车-商品id，用来批量添加
      quantity: [], //加入购物车-商品数量-批量添加
      desc: [], //加入购物车-备注-批量添加
      time_order: "", //时间排序
      price_order: "",
      attribute: "", //属性
      type: "",
      loading: true, //图片懒加载
      graffiti: false, //涂鸦弹窗
      graffitiGoods: {}, //涂鸦商品
      doodle: "",
      load: true,
      search: "",
      zhuangtai: true,
      imgPath: {},
      // time: null,
    };
  },
  //计算属性
  computed: {},
  //监控data中的数据变化
  watch: {
    graffitiGoods(newVal, oldVal) {
      deep: true, console.log(newVal);
      console.log(oldVal);
    },
    fullWidth(val) {
      // console.log(val);
    },
    productList: {
      deep: true,
      handler: function (newVal, oldVal) {
        // console.log("newValue", newVal);
        // console.log("oldValue", oldVal.name);
      },
    },
    load(val) {
      // console.log(val);
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // if (this.$route.params.search) {
    // this.search = this.$route.params.search;
    // }
    // console.log(this.$store.state.search);
    try {
      if (this.$route.params.name == undefined) {
        this.title = "все";
        // console.log(666);
      } else {
        this.title = this.$route.params.name;
        this.firstClassClassBelow1;
        this.classificationId_1 = this.$route.params.id;
      }
    } catch (error) {
      console.log(error);
    }

    this.getOneCat();
    this.ItemList();
    this.newItem();
    // this.ItemNewList();
  },
  //方法集合
  methods: {
    subscript(i) {
      // console.log(i);
      this.subscriptIndex = i;
    },
    /**
     * 控制涂鸦加载
     */
    loads() {
      this.load = false;
      // console.log(66666666);
    },
    /**
     * 获取点击商品对象
     */
    graffitiPopUpWindow(item, index, j) {
      // try {
      //   if (k == 1) {
      //     this.newItem = item;
      //   }
      // } catch (error) {}

      this.subscriptIndex = 0;
      // console.log(item);
      // console.log(item);
      this.graffiti = true;
      // console.log(this.$refs.tuya[index]);
      // let dom = this.$refs.tuya[index];
      this.load = true;
      this.$nextTick(() => {
        this.$refs.graffiti.initialization();
      });
      console.log(item.images.length);
      // if (item.images.length == 2) {
      //   console.log(666666);
      //   // var box = document.getElementsByClassName("el-carousel__arrow")[0];
      //   // box.remove();
      // }
      this.graffitiGoods = item;
      this.graffitiGoodsIndex = index;
      this.commodity = index;
      if (j === 1) {
        this.imgPath = this.newList[index];
      } else {
        this.imgPath = this.productList[index];
      }

      // this.imgUrl = item.thumb;
      // console.log(item);
      // console.log(item.thumb);
      this.$forceUpdate();
      // this.time = setTimeout(() => {
      //   if (this.load) {
      //     this.$message.error("Перезарядка перегружена");
      //     this.graffiti = false;
      //     clearTimeout(time);
      //   }
      // }, 15000);
    },
    operationalData(val, id) {
      this.productList[this.commodity].graffiti_img = val;
      if (this.commodity < 4) {
        this.newList.forEach((item) => {
          if (item.id == id) {
            this.productList[this.commodity].graffiti_img = val;
            this.newList[this.commodity].graffiti_img = val;
          }
        });
      }

      console.log(id);
      this.$forceUpdate();
      // console.log(val);
    },
    /**
     * 关闭涂鸦弹窗
     */
    handleClose(done) {
      done();
      // clearTimeout(this.time);
      this.load = true;
      this.doodle = new Date().getTime();
      this.imgUrl = null;
      let ele = document.getElementById("canvas");
      if (ele) {
        ele.remove();
      }
      console.log(this.graffitiGoods);
    },

    /**
     * 属性列表
     */
    determine(val) {
      this.attribute = val.join("|");
      this.ItemList();
    },
    /**
     * 涂鸦添加购物车
     */
    addShowToShoppingCart() {
      this.graffiti = false;
      // console.log(this.graffitiGoods);
      console.log(this.graffitiGoods.added);
      console.log(this.graffitiGoods);
      if (this.graffitiGoods.cartinfo.quantity.trim() == "") {
        if (this.graffitiGoods.added) {
          this.api
            .remove({
              token: localStorage.getItem("token"),
              item_id: this.graffitiGoods.id,
            })
            .then((res) => {
              this.Toast(res);
              if (res.status == 1) {
                this.$refs.breadCrumbs.doCount();
                console.log(this.newList);
                this.newList.forEach((item, index) => {
                  if (item.id == this.graffitiGoods.id) {
                    item = this.graffitiGoods;
                    item.added = false;
                    item.quantity = "";
                  }
                });
                // this.productList[this.commodity].added = false;
                this.productList.forEach((item, index) => {
                  if (item.id == this.graffitiGoods.id) {
                    item == this.graffitiGoods;
                    item.added = false;
                    item.quantity = "";
                  }
                });
                this.$forceUpdate();
              }
            });
          this.$refs.breadCrumbs.doCount();
        } else {
          this.$message.warning("Введите количество");
        }
        return;
      }
      let data = {
        token: localStorage.getItem("token"),
        item_id: this.graffitiGoods.id,
        quantity: this.graffitiGoods.cartinfo.quantity,
        desc: this.graffitiGoods.cartinfo.desc,
        type: "",
      };
      this.api.add(data).then((res) => {
        // console.log(res);
        this.Toast(res);
        if (res.status == 1) {
          this.$refs.breadCrumbs.doCount();
          console.log(this.commodity);
          // if (this.commodity < 4) {
          //   this.newList[this.commodity] = this.graffitiGoods;
          //   this.newList[this.commodity].added = true;
          //   this.$forceUpdate();
          // }
          this.newList.forEach((item, index) => {
            console.log(item.id);
            if (item.id == this.graffitiGoods.id) {
              item = this.graffitiGoods;
              item.added = true;
            }
          });
          this.productList.forEach((item, index) => {
            if (item.id == this.graffitiGoods.id) {
              item == this.graffitiGoods;
              item.added = true;
              this.$forceUpdate();
            }
          });
          this.graffitiGoods.note = "";
          this.graffitiGoods.num = "";
          this.$forceUpdate();
        }
      });
    },

    /**
     * 加入购物车
     */
    addToShoppingCart(item, index) {
      if (!item.cartinfo.quantity.trim()) {
        return this.$message.error("Введите количество");
      }
      if (item.cartinfo.quantity == 0 || item.cartinfo.quantity == null) {
        // if (item.added) {
        this.api
          .remove({
            token: localStorage.getItem("token"),
            item_id: item.id,
          })
          .then((res) => {
            this.Toast(res);
            if (res.status == 1) {
              this.$refs.breadCrumbs.doCount();
              item.added = false;
            }
          });
        // } else {
        // this.$message.message('警告哦，这是一条警告消息');
        // }

        return;
      }
      let data = {
        token: localStorage.getItem("token"),
        item_id: item.id,
        quantity: item.cartinfo.quantity,
        desc: item.cartinfo.desc,
        type: "",
      };
      this.api.add(data).then((res) => {
        // console.log(res);
        this.Toast(res);
        if (res.status == 1) {
          this.$refs.breadCrumbs.doCount();
          item.added = true;
          // item.note = "";
          // item.num = "";
          this.$forceUpdate();
        }
      });
    },

    /**
     * 时间排序
     */
    timeSorting(i) {
      this.time_order = i;
      this.ItemList();
    },

    /**
     * 价格排序
     */
    priceSorting(i, j) {
      if (i == 1) {
        this.price_order = j;
        this.time_order = "";
      } else {
        this.time_order = j;
        this.price_order = "";
      }
      this.ItemList();
    },

    /**
     * 切换大图
     */
    setLargePicture(bool) {
      this.largePicture = bool;
      this.$forceUpdate();
      this.$forceUpdate();
    },

    clear() {
      clearTimeout(this.timer2);
    },
    /**
     * 获取商品列表
     */
    ItemList(i) {
      // console.log(this.time_order);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      let data = {
        price_order: this.price_order,
        time_order: this.time_order,
        keywords: this.$store.state.search,
        p: i ? i : 1,
        cid_1: this.classificationId_1,
        cid_2: this.classificationId_2,
        cid_3: this.classificationId_3,
        token: localStorage.getItem("token"),
        is_cart: this.commodityId,
        attribute: this.attribute,
      };
      this.api.ItemList(data).then((res) => {
        console.log(res);
        // console.log(res.data.count);
        this.productList = res.data.list;
        console.log(this.productList);
        try {
          this.productList.forEach((item, index) => {
            // this.$set(item, "num", null);
            // this.$set(item, "note", "");
            // index % 2 == 0 ? (item.graffiti_img = 'https://jinxiaocun-1304679170.cos.eu-moscow.myqcloud.com/Uploads/Picture/2021-05-05/609204c120086.jpg') : (item.graffiti_img = 'https://xuanrankuajing.oss-us-west-1.aliyuncs.com/image/shouhou_Image/161423670248bX9.png');
            item.graffiti_img = item.graffiti_img
              ? item.graffiti_img +
                "?imageMogr2/format/heif?imageMogr2/thumbnail/636x"
              : item.images[0] +
                "?imageMogr2/format/heif?imageMogr2/thumbnail/636x";
            console.log(item.cartinfo);
            this.$set(item, "added", item.cartinfo == null ? false : true);
            if (item.cartinfo == null) {
              item.cartinfo = {};
              this.$set(item.cartinfo, "quantity", "");
              this.$set(item.cartinfo, "desc", "");
              this.$set(item.cartinfo, "quantity", "");
            }
            if (this.zhuangtai === true) {
              this.zhuangtai = false;
              // for (let index = 0; index < 4; index++) {
              //   // console.log(res.data.cate[index]);
              //   this.newList.push(res.data.list[index]);
              // }
            }
          });
        } catch (error) {}

        console.log(this.productList);
        this.totalNumber = res.data.count;
      });
    },
    newItem() {
      this.api.newItem({ token: localStorage.getItem("token") }).then((res) => {
        console.log(res);
        this.newList = res.data;
        this.newList.forEach((item, index) => {
          // this.$set(item, "num", null);
          // this.$set(item, "note", "");
          // index % 2 == 0 ? (item.graffiti_img = 'https://jinxiaocun-1304679170.cos.eu-moscow.myqcloud.com/Uploads/Picture/2021-05-05/609204c120086.jpg') : (item.graffiti_img = 'https://xuanrankuajing.oss-us-west-1.aliyuncs.com/image/shouhou_Image/161423670248bX9.png');
          item.graffiti_img = item.graffiti_img
            ? item.graffiti_img +
              "?imageMogr2/format/heif?imageMogr2/thumbnail/636x"
            : item.images[0] +
              "?imageMogr2/format/heif?imageMogr2/thumbnail/636x";
          console.log(item.cartinfo);
          this.$set(item, "added", item.cartinfo == null ? false : true);
          if (item.cartinfo == null) {
            item.cartinfo = {};
            this.$set(item.cartinfo, "quantity", "");
            this.$set(item.cartinfo, "desc", "");
            this.$set(item.cartinfo, "quantity", "");
          }
        });
      });
    },
    /**
     * 获取一级分类
     */
    getOneCat() {
      this.api.index({ type: 2 }).then((res) => {
        if (res.status == 1) {
          // console.log(res);
          this.firstClass = res.data.cate;
          res.data.cate.forEach((item, index) => {
            if (item.id == this.classificationId_1) {
              this.firstClassClassBelow = index;
            }
          });
        }
      });
    },
    // ItemNewList() {
    //   this.api.ItemNewList().then((res) => {

    //   });
    // },

    /**
     * 获取二级
     */
    getCategory(cat_id) {
      // console.log(cat_id);
      this.api
        .getCategory({
          cat_id,
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.twoClass = res.data;
          if (res.data.length) {
            this.secondaryClassification = true;
            this.twoList = res.data;
          } else {
            this.secondaryClassification = false;
          }
          this.$forceUpdate();
        });
    },

    /**
     * 获取三级分类
     */
    getThreeCat(cat_id) {
      this.api
        .getThreeCat({ cat_id, token: localStorage.getItem("token") })
        .then((res) => {
          // console.log(res);
          if (res.data.length) {
            this.level_3Classification = true;
            this.threeList = res.data;
          } else {
            this.level_3Classification = false;
            this.threeList = res.data;
          }
        });
    },

    /**
     * 点击分类事件
     */
    clickOnTheTitle(i, index, title, id) {
      this.$store.commit("setSearch", "");
      this.attribute = "";
      this.secondaryClassification = false;
      this.level_3Classification = false;
      // this.firstClassClassBelow1 = "a";
      // this.level_3ClassificationIndex2 == null;
      // this.secondaryClassificationSubscript2 = null;
      // this.productList = [];
      this.title = title;
      this.classificationId_1 = null;
      this.classificationId_2 = null;
      this.classificationId_3 = null;
      if (i == 1) {
        if (index == null) {
          this.title = "все";
          this.classificationId_1 = null;
        } else {
          this.classificationId_1 = id;
        }
        this.firstClassClassBelow = index;
        this.$refs.crumbs.getAttribute(id, 1);
        // this.classificationId_2 = null;
        // this.classificationId_3 = null;
      } else if (i == 2) {
        this.secondaryClassificationSubscript = index;
        this.firstClassClassBelow = this.firstClassClassBelow1;
        this.classificationId_2 = id;
        // this.classificationId_3 = null;
        this.$refs.crumbs.getAttribute(id, 2);
      } else {
        this.level_3ClassificationIndex = index;
        this.firstClassClassBelow = this.firstClassClassBelow1;
        this.secondaryClassificationSubscript =
          this.secondaryClassificationSubscript2;
        this.classificationId_3 = id;
        this.$refs.crumbs.getAttribute(id, 3);
      }
      this.ItemList();
    },
    /**
     * 显示二级、三级分类
     */
    switchClassification(i, index, title, id) {
      clearTimeout(this.timer);

      if (title == null) {
        this.secondaryClassification = false;
        this.level_3Classification = false;
        this.firstClassClassBelow1 = null;
        this.level_3ClassificationIndex2 == null;
        this.secondaryClassificationSubscript2 = null;
        return;
      }
      this.title2 = title;
      if (i == 1) {
        this.firstClassClassBelow1 = index;
        this.getCategory(id);
        this.secondaryClassificationSubscript = null;
        this.level_3ClassificationIndex = null;
        this.secondaryClassificationSubscript2 = null;
        this.level_3ClassificationIndex2 = null;
      } else if (i == 2) {
        this.level_3ClassificationIndex2 = null;
        this.secondaryClassificationSubscript2 = index;
        // this.level_3Classification = true;
        clearTimeout(this.timer2);
        this.getThreeCat(id);
      } else {
        this.level_3ClassificationIndex2 = index;
      }
    },
    subsequent(i) {
      if (i == 2) {
        this.timer2 = setTimeout(() => {
          this.level_3Classification = false;
          this.secondaryClassificationSubscript2 =
            this.secondaryClassificationSubscript;
        }, 300);
      }
    },
    /**
     * 一级移出
     */
    firstLevelMovedOut(i) {
      // this.firstClassClassBelow1 = 0;
      this.timer = setTimeout(() => {
        this.firstClassClassBelow1 = "a";
        this.level_3ClassificationIndex2 == null;
        this.secondaryClassificationSubscript2 = null;
        this.secondaryClassification = false;
        this.level_3Classification = false;
      }, 300);
    },

    /**
     * 二级移入
     */
    secondaryTransfer(i) {
      clearTimeout(this.timer);
    },

    /**
     * 计算千分位
     */
    calculateThePrice(str) {
      // console.log(str.toString());
      return num(str);
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$refs.crumbs.getAttribute(this.classificationId_1);

    // this.initCanvas();
  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
/deep/ .el-carousel__arrow {
  background-color: rgba(7, 7, 7, 0.5);
}

/deep/ .el-dialog {
  margin-top: 5vh !important;
}

/deep/ .aoligei {
  height: 636px;
}

/deep/ .el-carousel__container {
  height: 636px;

  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

/deep/ .path {
  stroke: #e9ad61;
}

/deep/ .el-image__inner {
  object-fit: cover;
}

/deep/ .el-carousel__indicators {
  display: none;
}

/deep/ .el-dialog__body {
  padding-top: 0;
  // padding-bottom: 92px;
  position: relative;

  .canvas-container {
    width: 636px;
    height: 636px;
    opacity: 1;
    display: inline-block;
    position: relative;
    // text-align: center;
    .position {
      text-align: center;
      display: inline-block;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: 12px;
      width: 68px;
      height: 26px;
      background: #ff3939;
      opacity: 0.74;
      border-radius: 18px;
      z-index: 3;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #ffffff;
      transition: all 0.2s;
    }
  }

  .information {
    display: inline-block;
    width: 365px;
    height: 200px;
    vertical-align: top;
    padding-top: 20px;
    padding-left: 18px;

    .introduction {
      height: 86px;
      display: inline-block;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      opacity: 1;
    }

    p {
      height: 22px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      opacity: 1;

      input {
        padding: 0 12px;
        width: 69px;
        height: 22px;
        background: #f5f5f5;
        opacity: 1;
        border: none;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 22px;
        color: #333333;
        opacity: 1;
      }
    }

    .join {
      margin-top: 55px;
      margin-left: 82px;
      width: 232px;
      height: 50px;
      background: #edc18a;
      opacity: 1;
      border-radius: 6px;
      border: none;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      color: #ffffff;
      opacity: 1;
    }

    .favorable {
      margin-top: 15px;

      p {
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
        opacity: 1;
        margin-bottom: 6px;

        span {
          font-weight: 400;
          color: #ff3939;
        }
      }
    }

    .note {
      background: #f8f8f8;
      padding: 7px;
      width: 365px;
      margin-bottom: 53px;

      img {
        width: 14px;
        height: 14px;
        vertical-align: top;
        margin-top: 2px;
        margin-right: 3px;
      }

      textarea {
        width: 330px;
        height: 163px;
        background: #f8f8f8;
        opacity: 1;
        border: none !important;
        resize: none;
        // padding: 7px;
        outline: none;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
      }
    }
  }
}

.container {
  // position: relative;
  .lft {
    left: -80px;
  }
  .content {
    margin-top: 20px;
    position: relative;

    .left {
      display: inline-block;
      position: relative;
      position: fixed;
      z-index: 99;
      width: 220px;

      .quanbu {
        width: 218px !important;
        // border-right: 1px solid #e6e6e6;
        // position: absolute;
        // opacity: 1 !important;
        // z-index: 1 !important;
        // border: none !important;
      }

      .classificationss,
      .secondary-classification,
      .san-classification {
        z-index: 1;
        display: inline-block;
        width: 100%;
        height: 400px;
        overflow-y: scroll;
        // white-space: nowrap;
        //横向滑动
        overflow-x: scroll;
        //滚动条消失
        &::-webkit-scrollbar {
          display: none;
        }

        // overflow: -Scroll;
        // overflow-y: hidden;
        // position: absolute;
        // left: 0;
        // top: 0;
        right: -17px;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: scroll;
        z-index: 2001;
        background: #ffffff;
        border: 1px solid #e6e6e6;

        .firstClassClassification:last-child {
          div {
            border: none;
          }
        }

        .firstClassClassification {
          width: 100%;
          height: 40px;
          background: #ffffff;
          transition: background-color 0.2s;
          // border-bottom: 1px solid #f6f6f6;
          cursor: pointer;
          opacity: 0;
          opacity: 1;
          color: #666666;

          div {
            padding: 0 12px 0 20px;
            height: 40px;
            position: relative;
            border-bottom: 1px solid #f6f6f6;
            overflow: hidden;
            // height: 100%;
            span {
              // overflow: hidden;
              line-height: 40px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;

              opacity: 1;
            }

            img {
              width: 16px;
              height: 16px;
              position: absolute;
              right: 12px;
              top: 0;
              bottom: 0;
              margin: auto 0;
            }
          }
        }

        .active {
          background: #edc18a !important;
          transition: background-color 0.2s;
          opacity: 1 !important;
          color: #ffffff;

          div {
            // border: none;
            border-bottom: 1px solid #edc18a;
            transition: border 0.2s;

            span {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 40px;

              opacity: 1;
            }
          }
        }
      }

      .new-product {
        margin-top: 40px;

        .title {
          position: relative;
          height: 22px;
          margin-bottom: 20px;

          img {
            width: 30px;
            height: 20px;
            margin-right: 12px;
            vertical-align: middle;
            display: inline-block;
            line-height: 18px;
            margin-top: -3px;
          }

          span {
            font-size: 16px;
            display: inline-block;
            height: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 20px;
            color: #ff3939;
            opacity: 1;
          }
        }

        &-list {
          width: 100%;

          .commodity {
            width: 100%;
            height: 220px;
            // background: #333;
            position: relative;
            margin-bottom: 14px;
            border: 1px solid #ff3b3b;
            opacity: 1;
            border-radius: 6px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 5px;
            }

            .name {
              display: block;
              text-align: center;
              position: absolute;
              top: 0;
              left: 0;
              width: 51px;
              height: 22px;
              background: #ff3b3b;
              opacity: 1;
              font-size: 14px;
              border-radius: 4px 0px 4px 0px;
              font-weight: 400;
              line-height: 20px;
              color: #ffffff;
              opacity: 1;
            }

            .money {
              position: absolute;
              padding: 0 4px;
              bottom: 0;
              right: 0;
              display: block;
              text-align: center;
              position: absolute;
              height: 29px;
              background: #ff3b3b;
              opacity: 1;
              font-size: 21px;
              border-radius: 4px 0px 4px 0px;
              font-weight: bold;
              line-height: 29px;
              color: #ffffff;
              opacity: 1;
            }

            .added {
              position: absolute;
              margin: auto;
              width: 66px;
              height: 66px;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
            }
          }
        }
      }
    }

    .secondary-classification {
      background: #333;
      position: absolute;
      top: 0;
      width: 220px !important;
      left: 219px;
    }

    .san-classification {
      background: #333;
      position: absolute;
      width: 220px !important;
      top: 0;
      left: 438px;
    }
  }

  .right {
    display: inline-block;
    position: absolute;
    width: 910px;
    top: 0;
    margin-left: 250px;
    z-index: 98 !important;

    .air {
      position: absolute;
      margin: 0 auto;
      width: 200px;
      opacity: 0.5;
      left: 0;
      top: 100px;
      right: 0;
    }

    .productList {
      position: relative;

      .el-divider {
        margin: 20px 0;
        width: 810px;
      }

      .img {
        display: inline-block;
        position: relative;
        width: 180px;
        height: 180px;

        .productList-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }

        .el-image {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          overflow: hidden;

          img {
            border-radius: 4px;
          }
        }

        img {
          border-radius: 4px;
        }

        .image-slot {
          width: 100%;
          height: 100%;

          text-align: center;

          span {
            border-radius: 4px;
            display: inline-block;
            width: 100%;
            height: 100%;
            line-height: 180px;
            color: #e5e5e5;
            border: 1px solid #e5e5e5;
          }
        }

        .added {
          position: absolute;
          margin: auto;
          width: 66px;
          height: 66px;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }

        .sort {
          position: absolute;
          width: 32px;
          height: 32px;
          right: 0;
          top: 0;
        }
      }

      .product-message {
        padding-left: 20px;
        display: inline-block;
        height: 180px;
        width: 710px;
        position: relative;
        vertical-align: top;
        overflow: hidden;

        .title {
          height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 19px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          opacity: 1;
          margin-bottom: 8px;
        }

        .content {
          margin-top: 0;
          margin-bottom: 12px;
          height: 34px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 18px;
          width: 100%;
          color: #999999;
          opacity: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .money {
          height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          color: #333333;
          opacity: 1;
          // margin-bottom: 12px;
          .cu-red {
            font-weight: bold;
            color: #ff3b3b;
            margin-right: 16px;
          }

          .num {
            display: inline-block;
            width: 48px;
            text-align: center;
            height: 24px;
            line-height: 24px;
            background: #f8f8f8;
            opacity: 1;
            margin-right: 4px;
            border: none;
          }

          .xi-red {
            color: #ff3b3b;
          }
        }

        .favorable {
          display: inline-block;
          margin-right: 64px;
          position: relative;
          margin-top: 12px;
        }

        .el-button {
          position: absolute;
          background: #edc18a;
          padding: 0;
          height: 32px;
          border: none;
          // width: 116px;
          padding: 0 14px;
          left: 170px;
          bottom: 0;

          span {
            padding: 0;
          }
        }

        .note {
          display: inline-block;
          overflow: hidden;
          position: absolute;
          right: 80px;
          // margin-left: 183px;
          bottom: 0;
          // left: 183px;
          span {
            // flex: 1;
            display: inline-block;
            margin-top: 0;
          }

          textarea {
            flex: 1;
            resize: none;
            display: inline-block;
            width: 240px;
            height: 72px;
            vertical-align: text-top;
            border: 1px solid #cecece;
            padding: 3px;
          }

          textarea:focus {
            border-color: #edc18a;
          }
        }

        .favorable {
          p {
            height: 19px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #333333;
            opacity: 1;
            margin-bottom: 6px;

            span {
              font-weight: 400;
              color: #ff3939;
            }
          }
        }
      }
    }

    .big-map {
      display: inline-block;
      width: 216px;
      height: 216px;
      margin-right: 15px;
      margin-bottom: 15px;
      border-radius: 4px;
      position: relative;

      .added {
        position: absolute;
        margin: auto;
        width: 66px;
        height: 66px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }

      .el-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }

      .image-slot {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        text-align: center;

        span {
          border-radius: 4px;
          display: inline-block;
          width: 100%;
          height: 100%;
          line-height: 216px;
          color: #e5e5e5;
          border: 1px solid #e5e5e5;
        }
      }

      .money {
        display: inline-block;
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0 5px;
        height: 30px;
        background: #ff3b3b;
        opacity: 1;
        border-radius: 4px 0px 4px 0px;
        font-size: 21px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 29px;
        color: #ffffff;
        opacity: 1;
        line-height: 30px;
      }
    }
  }

  .advertising {
    position: absolute;
    right: -190px;
    top: 0;
    width: 221px;
    height: 389px;
    // background: #333;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
